(() => {
  const box=document.querySelector('[data-checklist-signup]');
  const emit=(event,extra={})=>{window.dataLayer=window.dataLayer||[];window.dataLayer.push({event,content_asset:'protein-label-checklist',...extra});};
  document.querySelector('[data-checklist-print]')?.addEventListener('click',()=>{emit('protein_checklist_print');window.print();});
  if(!box)return;
  const form=box.querySelector('form'),status=box.querySelector('[data-checklist-status]'),button=form.querySelector('button');
  if('IntersectionObserver'in window){const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){emit('protein_checklist_form_view');observer.disconnect();}},{threshold:.3});observer.observe(box);}
  let accepted=false;
  form.addEventListener('submit',async event=>{
    event.preventDefault();if(accepted||button.disabled||!form.reportValidity()||!form.elements.consent.checked)return;
    const email=form.elements.email.value.trim();button.disabled=true;status.textContent='Submitting your subscription…';
    emit('protein_checklist_signup_submit');
    const controller=new AbortController(),timeout=setTimeout(()=>controller.abort(),15000);
    try{
      const payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Protein Label Checklist',
            profile: {data: {type: 'profile', attributes: {
              email,
              subscriptions: {email: {marketing: {consent: 'SUBSCRIBED'}}},
              properties: {
                'Paleo Pro Signup Asset': 'protein-label-checklist',
                'Paleo Pro Signup Page': window.location.pathname,
                'Paleo Pro Consent Text': 'I agree to receive marketing emails from Paleo Pro. I can unsubscribe anytime.',
                'Paleo Pro Consent Version': '2026-09-17'
              }
            }}}
          },
          relationships: {list: {data: {type: 'list', id: 'WWM8RZ'}}}
        }
      };
      const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=U7eEWE', {
        method: 'POST', signal: controller.signal,
        headers: {'Content-Type': 'application/vnd.api+json', revision: '2026-07-15'},
        body: JSON.stringify(payload)
      });
      if(!response.ok)throw new Error('Subscription request failed');
      status.textContent='Thanks. Your subscription request was accepted. Look for Paleo Pro’s welcome email, and confirm your address if asked. The checklist is ready to use above.';
      accepted=true;emit('protein_checklist_signup_accepted',{destination_list:'WWM8RZ'});form.reset();button.textContent='Request accepted';
    }catch(error){status.textContent='We couldn’t submit your signup. Please try again. You can still use and print the checklist above.';emit('protein_checklist_signup_error');}
    finally{clearTimeout(timeout);button.disabled=accepted;}
  });
})();
